var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#008FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6711 9.46857C14.3859 9.46857 14.1547 9.25875 14.1547 9V8.53088H11.5605C11.2753 8.53088 11.0441 8.32107 11.0441 8.06232C11.0441 7.80357 11.2753 7.59375 11.5605 7.59375H14.6711C14.9563 7.59375 15.1875 7.80357 15.1875 8.06232V9C15.1875 9.25875 14.9569 9.46857 14.6711 9.46857ZM12.1123 9.46857H13.1445C13.4297 9.46857 13.6609 9.67838 13.6609 9.93713C13.6609 10.1959 13.4303 10.4063 13.1445 10.4063H11.5605C11.4782 10.4065 11.397 10.3884 11.3226 10.3534L8.31206 8.53088H7.44469C7.1595 8.53088 6.92831 8.32107 6.92831 8.06232C6.92831 7.80357 7.15894 7.59375 7.44469 7.59375H8.47687C8.58825 7.59375 8.69119 7.62582 8.77556 7.68038L11.7186 9.46913L12.1123 9.46857ZM8.47687 9.46857C8.76206 9.46857 8.99325 9.67838 8.99325 9.93713C8.99325 10.1959 8.76206 10.4063 8.47687 10.4063H7.44469C7.36244 10.4065 7.28117 10.3884 7.20675 10.3534L4.19625 8.53088H3.32888C3.04369 8.53088 2.8125 8.32107 2.8125 8.06232C2.8125 7.80357 3.04313 7.59375 3.32888 7.59375H4.36106C4.46688 7.59336 4.57057 7.62344 4.65975 7.68038L7.60275 9.46913L8.47687 9.46857ZM3.32888 9.46857H4.36106C4.64625 9.46857 4.87744 9.67838 4.87744 9.93769C4.87744 10.1964 4.64625 10.4063 4.36106 10.4063H3.32888C3.04369 10.4063 2.8125 10.1964 2.8125 9.93769C2.8125 9.67894 3.04313 9.46857 3.32888 9.46857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNxt);
export default __webpack_public_path__ + "static/media/nxt.873ea9d2d1be89a264a2d4e450f1d654.svg";
export { ForwardRef as ReactComponent };